import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddNewPage } from './addNew/addNew';
import { NewPage } from './new/new';

@Component({
  selector: 'page-news',
  templateUrl: 'news.html',
  providers : [HttpClient]
})
export class NewsPage {

	news;
  searchQuery = '';

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  events : Events;

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.events = events;
      this.events.subscribe('addNew:done',()=>{
        this.httpCallNews('',1000);
      });
      this.events.subscribe('new:update',()=>{
        this.httpCallNews('',1000);
      });
      this.events.subscribe('new:delete',()=>{
        this.httpCallNews('',1000);
      });
      this.httpCallNews('',1000);
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallNews(this.searchQuery,50);
      }else{
        this.httpCallNews(this.searchQuery,1000);
      }
    }

    httpCallNews(name,max){
      this.httpClient.get('/news?name='+name+'&max='+max,(error,data)=>{
        this.news = data.json();
      });
    }

    onClickAdd(){
      this.navCtrl.push(AddNewPage);
    }

    onClickNew(thenew){
      this.navCtrl.push(NewPage,{id : thenew.id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/news/news.ts